/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Invite_Adminwarning1Inputs */

const es_admin_users_invite_adminwarning1 = /** @type {(inputs: Admin_Users_Invite_Adminwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este usuario tendrá acceso completo a toda la información y configuración de la empresa.`)
};

const en_admin_users_invite_adminwarning1 = /** @type {(inputs: Admin_Users_Invite_Adminwarning1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user will have full access to all company information and settings.`)
};

/**
* | output |
* | --- |
* | "This user will have full access to all company information and settings." |
*
* @param {Admin_Users_Invite_Adminwarning1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_invite_adminwarning1 = /** @type {((inputs?: Admin_Users_Invite_Adminwarning1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Invite_Adminwarning1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_invite_adminwarning1(inputs)
	return en_admin_users_invite_adminwarning1(inputs)
});
export { admin_users_invite_adminwarning1 as "admin.users.invite.adminWarning" }